export const BENCHMARK_TYPES = [
  {
    id: "industry_average",
    label: "Industry Average",
    shortLabel: "Industry Avg",
    description:
      "Midpoint of the sector's peer or researched LB/UB range on every KPI, scored with the same SI normalisation.",
    color: "#64748b",
  },
  {
    id: "industry_leaders",
    label: "Industry Leaders",
    shortLabel: "Leaders",
    description:
      "Best observed peer value on every KPI (upper bound where higher is better, lower bound where lower is better).",
    color: "#0d9488",
  },
  {
    id: "previous_assessment",
    label: "Previous Assessment",
    shortLabel: "Prior Year",
    description:
      "Your most recent prior SI assessment for year-over-year progress tracking.",
    color: "#6366f1",
  },
  {
    id: "global_best_practices",
    label: "Global Best Practices",
    shortLabel: "Global Best",
    description:
      "Best-in-class value from the researched bounds (SBTi/IEA pathways, GRI/SASB/ILO guidance) on every KPI.",
    color: "#059669",
  },
  {
    id: "custom",
    label: "Custom Benchmark Groups",
    shortLabel: "Custom",
    description:
      "User-defined target scores saved for your organization or stakeholder groups.",
    color: "#14b8a6",
  },
  {
    id: "request_peer_companies",
    label: "Request Peer Companies",
    shortLabel: "Request Peers",
    description:
      "Request a custom benchmark against companies you select. Processed manually by the GE3S team.",
    color: "#0f766e",
  },
];

export const SECTION_META = [
  { key: "base", label: "Base / Sector", color: "#02b880" },
  { key: "environment", label: "Environmental", color: "#3b82f6" },
  { key: "social", label: "Social", color: "#f59e0b" },
  { key: "governance", label: "Governance & Economics", color: "#8b5cf6" },
];

export const CUSTOM_BENCHMARK_STORAGE_KEY = "si_custom_benchmark_groups";
